import { RadioButton } from "primereact/radiobutton";
import React, { Component, Fragment } from "react";
import AnsItemUI from "./AnsItemUI";
import { Checkbox } from "primereact/checkbox";

class AnsContainerUI extends Component {
  constructor() {
    super();
    this.ansRefArr = [];
  }

  render = () => {
    let { activity, quizViewer, ansModel } = this.props;
    let { ansContainer } = activity;
    let { tfAnsArr } = ansContainer;
    let { selectedStyle, multipleAnswers } = ansContainer;
    let { quizViwerModel } = quizViewer.state;
    return (
      <Fragment>
        <div
          id="ansContainer"
          //  className="d-flex flex-column "
          style={{
            textAlign:
              quizViwerModel.callbackData.dir == "ltr" ? "left" : "right",
            marginBottom: "3rem",
            width: "105%",
          }}
        >
          {/* style={(selectedStyle!=null)?selectedStyle[0].style:{}} */}
          <ol
            type="a"
            style={{
              multipleAnswers,
            }}
          >
            {tfAnsArr.map((ansModel, index) => {
              return multipleAnswers ? (
                <>
                  <li>
                    <Checkbox
                      checked={ansModel.isSelected}
                      value={this.selectAns}
                      className="check-box"
                    />
                    <AnsItemUI
                      quizViewer={quizViewer}
                      ansModel={ansModel}
                      ansContainer={ansContainer}
                      key={index}
                    />
                  </li>
                </>
              ) : (
                <>
                  <li>
                    <RadioButton
                      checked={ansModel.isSelected}
                      className="radio-box"
                    ></RadioButton>
                    <AnsItemUI
                      quizViewer={quizViewer}
                      ansModel={ansModel}
                      ansContainer={ansContainer}
                      key={index}
                    />
                  </li>
                </>
              );
            })}
          </ol>
        </div>
      </Fragment>
    );
  };

  selectAns = (e, ans, index) => {
    if (ans.isSelected) {
      this.ansRefArr[index].current.style.backgroundColor = "white";
      ans.isSelected = false;
    } else {
      this.ansRefArr[index].current.style.backgroundColor = "gray";
      ans.isSelected = true;
    }
  };
}

export default AnsContainerUI;
